import angular from 'angular'
import './offers.service'
import './edit/edit.controller'

angular
  .module('admin.offers', ['admin.offers.service', 'admin.offers.edit'])
  .controller('OffersCtrl', OffersCtrl)

/** @ngInject */
function OffersCtrl($scope, $q, $state, $timeout, $stateParams, OffersService, CouponsService) {
  var vm = this
  vm.items = []

  vm.perPage = 25
  vm.sortType = 'id-desc'
  vm.sortReverse = false
  vm.sortType2 = 'ts-p-desc'
  vm.sortReverse2 = false
  vm.sortType3 = 'ts-p-desc'
  vm.sortReverse3 = false

  function reloadPaginationDraft() {
    vm.totalItems = 0
    vm.oldPage = 0
    vm.currentPage = 25
    vm.first = true
    vm.totalItems = 0
    vm.pagination = {
      current: 1,
    }
  }

  function reloadPaginationPublish() {
    vm.totalItems2 = 0
    vm.oldPage2 = 0
    vm.currentPage2 = 25
    vm.first2 = true
    vm.totalItems2 = 0
    vm.pagination2 = {
      current: 1,
    }
  }

  function reloadPaginationArchived() {
    vm.totalItems3 = 0
    vm.oldPage3 = 0
    vm.currentPage3 = 25
    vm.first3 = true
    vm.totalItems3 = 0
    vm.pagination3 = {
      current: 1,
    }
  }

  reloadPaginationDraft()
  reloadPaginationPublish()
  reloadPaginationArchived()
  loadPublished(1)
  loadUnpublished(1)
  loadArchived(1)

  var tab = localStorage.getItem('offers')
  if (tab !== null) {
    if (tab === 'draft') {
      $('#published').removeClass('active')
      $('#archived').removeClass('active')
      $('#draft').addClass('active')
      $('#drafttab').addClass('active')
    } else if (tab === 'published') {
      $('#draft').removeClass('active')
      $('#archived').removeClass('active')
      $('#published').addClass('active')
      $('#publishedtab').addClass('active')
    } else {
      $('#draft').removeClass('active')
      $('#published').removeClass('active')
      $('#archived').addClass('active')
      $('#archivedtab').addClass('active')
    }
  } else {
    $('#draft').addClass('active')
    $('#drafttab').addClass('active')
  }

  vm.tabDraft = function () {
    $('#published').removeClass('active')
    $('#archived').removeClass('active')
    $('#draft').addClass('active')
    localStorage.setItem('offers', 'draft')
  }

  vm.tabPublished = function () {
    $('#draft').removeClass('active')
    $('#archived').removeClass('active')
    $('#published').addClass('active')
    localStorage.setItem('offers', 'published')
  }

  vm.tabArchived = function () {
    $('#draft').removeClass('active')
    $('#published').removeClass('active')
    $('#archived').addClass('active')
    localStorage.setItem('offers', 'archived')
  }

  var oldSortType, oldSortType2, oldSortType3
  function loadUnpublished(pageNumber) {
    if (pageNumber === 1) {
      vm.pagination.current = 1
    }
    if (!vm.first) {
      vm.currentPage = pageNumber * 25
      vm.oldPage = vm.currentPage - 25
    } else {
      vm.first = false
    }

    oldSortType = angular.copy(vm.sortType)
    OffersService.listUnpublish(vm.oldPage, 25, vm.sortType).then(function (result) {
      var offers = result.results
      if (vm.totalItems === 0) {
        vm.totalItems = result.ct
      }
      for (var i = 0; i < offers.length; i++) {
        if (offers[i]['ts-p'] !== undefined) {
          offers[i].isPub = true
          offers[i]['ts-p'] = new Date(
            parseInt(
              offers[i]['ts-p'].toString().substring(0, offers[i]['ts-p'].toString().length - 3),
            ),
          )
        } else {
          offers[i].isPub = false
        }

        if (offers[i]['ts-x'] !== undefined) {
          offers[i]['ts-x'] = new Date(
            parseInt(
              offers[i]['ts-x'].toString().substring(0, offers[i]['ts-x'].toString().length - 3),
            ),
          )
        }

        if (offers[i].st === 0) {
          offers[i].status = 'Draft'
        } else if (offers[i].st === 1) {
          offers[i].status = 'Published'
        } else {
          offers[i].status = 'Archived'
        }

        if (offers[i].k === 0) {
          offers[i].type = 'Unknown'
        } else if (offers[i].k === 1) {
          offers[i].type = 'Coin Product'
        } else if (offers[i].k === 2) {
          offers[i].type = 'Bundle'
        } else if (offers[i].k === 3) {
          offers[i].type = 'Deep Link'
        } else if (offers[i].k === 4) {
          offers[i].type = 'Cash'
        } else if (offers[i].k === 5) {
          offers[i].type = 'Coupon'
        } else {
          offers[i].type = 'Unknown'
        }

        if (offers[i]['k-type'] === 0) {
          offers[i].trigger = 'Open App'
        } else if (offers[i]['k-type'] === 1) {
          offers[i].trigger = 'Bought Bundle'
        } else if (offers[i]['k-type'] === 2) {
          offers[i].trigger = 'Bundle Purchase Failed'
        } else if (offers[i]['k-type'] === 3) {
          offers[i].trigger = 'Below Coin Threshold'
        } else if (offers[i]['k-type'] === 4) {
          offers[i].trigger = 'Bought Listing'
        } else if (offers[i]['k-type'] === 5) {
          offers[i].trigger = 'Listing Purchase Failed'
        } else if (offers[i]['k-type'] === 6) {
          offers[i].trigger = 'Fyber Error'
        } else if (offers[i]['k-type'] === 7) {
          offers[i].trigger = 'New Level'
        } else if (offers[i]['k-type'] === 8) {
          offers[i].trigger = 'Client'
        }

        if (pageNumber === 1 && i === 0) {
          offers[i].firstRow = true
        }

        if (offers.length - 1 === i && offers.length < vm.currentPage) {
          offers[i].lastRow = true
        }
      }
      vm.sortType = oldSortType
      vm.itemsDraft = offers
    })
  }

  function loadPublished(pageNumber) {
    if (pageNumber === 1) {
      vm.pagination2.current = 1
    }
    if (!vm.first) {
      vm.currentPage2 = pageNumber * 25
      vm.oldPage2 = vm.currentPage2 - 25
    } else {
      vm.first2 = false
    }

    oldSortType2 = angular.copy(vm.sortType2)
    OffersService.listPublish(vm.oldPage2, 25, vm.sortType2).then(function (result) {
      var offers = result.results
      if (vm.totalItems2 === 0) {
        vm.totalItems2 = result.ct
      }
      for (var i = 0; i < offers.length; i++) {
        if (offers[i]['ts-p']) {
          offers[i].isPub = true
          offers[i]['ts-p'] = new Date(
            parseInt(
              offers[i]['ts-p'].toString().substring(0, offers[i]['ts-p'].toString().length - 3),
            ),
          )
        } else {
          offers[i].isPub = false
        }

        if (offers[i]['ts-x'] !== undefined) {
          offers[i]['ts-x'] = new Date(
            parseInt(
              offers[i]['ts-x'].toString().substring(0, offers[i]['ts-x'].toString().length - 3),
            ),
          )
        }

        if (offers[i].st === 1) {
          offers[i].isPub = true
        } else {
          offers[i].isPub = false
        }

        if (offers[i].st === 0) {
          offers[i].status = 'Draft'
        } else if (offers[i].st === 1) {
          offers[i].status = 'Published'
        } else {
          offers[i].status = 'Archived'
        }

        if (offers[i].k === 0) {
          offers[i].type = 'Unknown'
        } else if (offers[i].k === 1) {
          offers[i].type = 'Coin Product'
        } else if (offers[i].k === 2) {
          offers[i].type = 'Bundle'
        } else if (offers[i].k === 3) {
          offers[i].type = 'Deep Link'
        } else if (offers[i].k === 4) {
          offers[i].type = 'Cash'
        } else if (offers[i].k === 5) {
          offers[i].type = 'Coupon'
        } else {
          offers[i].type = 'Unknown'
        }

        if (offers[i]['k-type'] === 0) {
          offers[i].trigger = 'Open App'
        } else if (offers[i]['k-type'] === 1) {
          offers[i].trigger = 'Bought Bundle'
        } else if (offers[i]['k-type'] === 2) {
          offers[i].trigger = 'Bundle Purchase Failed'
        } else if (offers[i]['k-type'] === 3) {
          offers[i].trigger = 'Below Coin Threshold'
        } else if (offers[i]['k-type'] === 4) {
          offers[i].trigger = 'Bought Listing'
        } else if (offers[i]['k-type'] === 5) {
          offers[i].trigger = 'Listing Purchase Failed'
        } else if (offers[i]['k-type'] === 6) {
          offers[i].trigger = 'Fyber Error'
        } else if (offers[i]['k-type'] === 7) {
          offers[i].trigger = 'New Level'
        } else if (offers[i]['k-type'] === 8) {
          offers[i].trigger = 'Client'
        }

        if (pageNumber === 1 && i === 0) {
          offers[i].firstRow = true
        }

        if (offers.length - 1 === i && offers.length < vm.currentPage2) {
          offers[i].lastRow = true
        }
      }
      vm.sortType2 = oldSortType2
      vm.itemsPublish = offers
    })
  }

  function loadArchived(pageNumber) {
    if (pageNumber === 1) {
      vm.pagination3.current = 1
    }
    if (!vm.first) {
      vm.currentPage3 = pageNumber * 25
      vm.oldPage3 = vm.currentPage3 - 25
    } else {
      vm.first3 = false
    }

    oldSortType3 = angular.copy(vm.sortType3)
    OffersService.listArchived(vm.oldPage3, 25, vm.sortType3).then(function (result) {
      var offers = result.results
      if (vm.totalItems3 === 0) {
        vm.totalItems3 = result.ct
      }
      for (var i = 0; i < offers.length; i++) {
        if (offers[i]['ts-p']) {
          offers[i].isPub = true
          offers[i]['ts-p'] = new Date(
            parseInt(
              offers[i]['ts-p'].toString().substring(0, offers[i]['ts-p'].toString().length - 3),
            ),
          )
        } else {
          offers[i].isPub = false
        }

        if (offers[i]['ts-x'] !== undefined) {
          offers[i]['ts-x'] = new Date(
            parseInt(
              offers[i]['ts-x'].toString().substring(0, offers[i]['ts-x'].toString().length - 3),
            ),
          )
        }

        if (offers[i].st === 1) {
          offers[i].isPub = true
        } else {
          offers[i].isPub = false
        }

        if (offers[i].st === 0) {
          offers[i].status = 'Draft'
        } else if (offers[i].st === 1) {
          offers[i].status = 'Published'
        } else {
          offers[i].status = 'Archived'
        }

        if (offers[i].k === 0) {
          offers[i].type = 'Unknown'
        } else if (offers[i].k === 1) {
          offers[i].type = 'Coin Product'
        } else if (offers[i].k === 2) {
          offers[i].type = 'Bundle'
        } else if (offers[i].k === 3) {
          offers[i].type = 'Deep Link'
        } else if (offers[i].k === 4) {
          offers[i].type = 'Cash'
        } else if (offers[i].k === 5) {
          offers[i].type = 'Coupon'
        } else {
          offers[i].type = 'Unknown'
        }

        if (offers[i]['k-type'] === 0) {
          offers[i].trigger = 'Open App'
        } else if (offers[i]['k-type'] === 1) {
          offers[i].trigger = 'Bought Bundle'
        } else if (offers[i]['k-type'] === 2) {
          offers[i].trigger = 'Bundle Purchase Failed'
        } else if (offers[i]['k-type'] === 3) {
          offers[i].trigger = 'Below Coin Threshold'
        } else if (offers[i]['k-type'] === 4) {
          offers[i].trigger = 'Bought Listing'
        } else if (offers[i]['k-type'] === 5) {
          offers[i].trigger = 'Listing Purchase Failed'
        } else if (offers[i]['k-type'] === 6) {
          offers[i].trigger = 'Fyber Error'
        } else if (offers[i]['k-type'] === 7) {
          offers[i].trigger = 'New Level'
        } else if (offers[i]['k-type'] === 8) {
          offers[i].trigger = 'Client'
        }
      }
      vm.sortType3 = oldSortType3
      vm.itemsArchived = offers
    })
  }

  vm.pageChanged = function (newPage) {
    vm.sortType = oldSortType
    loadUnpublished(newPage)
    $('html, body').animate({ scrollTop: 0 }, 0)
  }

  vm.pageChanged2 = function (newPage) {
    vm.sortType2 = oldSortType2
    loadPublished(newPage)
    $('html, body').animate({ scrollTop: 0 }, 0)
  }

  vm.pageChanged3 = function (newPage) {
    vm.sortType3 = oldSortType3
    loadArchived(newPage)
    $('html, body').animate({ scrollTop: 0 }, 0)
  }

  vm.add = function () {
    $state.go('admin.offers.edit', { id: 0 })
  }

  vm.delete = function (item) {
    swal(
      {
        title: 'Are you Sure?',
        text: '',
        type: 'warning',
        showCancelButton: true,
        closeOnConfirm: true,
        closeOnCancel: true,
        animation: 'slide-from-top',
      },
      function (isConfirm) {
        if (isConfirm) {
          OffersService.remove(item.id).then(
            function () {
              if (vm.itemsDraft.length === 1 || vm.itemsDraft.length === 25) {
                $state.reload()
              } else {
                loadUnpublished(vm.pagination.current)
              }
              if (vm.itemsPublish.length === 1 || vm.itemsPublish.length === 25) {
                $state.reload()
              } else {
                loadPublished(vm.pagination2.current)
              }
              if (vm.itemsArchived.length === 1 || vm.itemsArchived.length === 25) {
                $state.reload()
              } else {
                loadArchived(vm.pagination3.current)
              }
            },
            function () {
              $timeout(function () {
                swal("You can't delete because has things associated with it", '', 'error')
              }, 750)
            },
          )
        } else {
          return
        }
      },
    )
  }

  vm.publish = function (item) {
    OffersService.publish(item.id).then(function () {
      reloadPaginationDraft()
      reloadPaginationPublish()
      vm.sortType = 'id-desc'
      vm.sortReverse = false
      vm.sortType2 = 'ts-p-desc'
      vm.sortReverse2 = false
      loadUnpublished(1)
      loadPublished(1)
    })
  }

  vm.unpublish = function (item) {
    OffersService.unpublish(item.id).then(function () {
      reloadPaginationDraft()
      reloadPaginationPublish()
      vm.sortType = 'id-desc'
      vm.sortReverse = false
      vm.sortType2 = 'ts-p-desc'
      vm.sortReverse2 = false
      loadUnpublished(1)
      loadPublished(1)
    })
  }

  vm.back = function () {
    loadUnpublished(1)
    loadPublished(1)
    loadArchived(1)
  }

  vm.disableTable = false
  vm.barConfig = {
    animation: 150,
    onEnd: function (/** ngSortEvent */ evt) {
      vm.disableTable = true
      var newIdx = parseInt(evt.newIndex) + 1
      OffersService.reorder(evt.model.id, newIdx).then(function () {
        vm.sortType = 'n-asc'
        vm.sortReverse = false
        vm.sortType2 = 'n-asc'
        vm.sortReverse2 = false
        loadUnpublished()
        loadPublished()
        vm.disableTable = false
      })
    },
  }

  vm.clone = function (item) {
    swal(
      {
        title: 'Are you Sure?',
        text: '',
        type: 'warning',
        showCancelButton: true,
        closeOnConfirm: true,
        closeOnCancel: true,
        animation: 'slide-from-top',
      },
      function (isConfirm) {
        if (isConfirm) {
          var model = {
            dis: item.dis,
            img: item.img,
            'k-type': item['k-type'],
            n: 1,
            opu: item.opu,
            st: 0,
            t: item.t,
            txt: item.txt,
            'txt-btn': item['txt-btn'],
            'txt-t': item['txt-t'],
          }

          if (item.k) {
            model.k = item.k
          }
          if (item.url) {
            model.url = item.url
          }
          if (item.cash) {
            model.cash = item.cash
          }
          if (item['id-cpn']) {
            CouponsService.get(item['id-cpn']).then(function (resCoupon) {
              var couponModel = angular.copy(resCoupon.results)
              couponModel.id = 0
              couponModel['ts-p'] = null
              couponModel.st = 0
              delete couponModel['ts']
              delete couponModel['ts-m']

              CouponsService.save(couponModel).then(function (resCoupon2) {
                model['id-cpn'] = resCoupon2.results.id

                OffersService.save(model).then(function (resultOffer) {
                  OffersService.listOfferSegmentation(item.id).then(function (result) {
                    var offersSegmentations = result.results
                    var promise = []
                    for (var i = 0; i < offersSegmentations.length; i++) {
                      promise.push(
                        OffersService.addOfferSegmentation(
                          resultOffer.results.id,
                          offersSegmentations[i].id,
                        ),
                      )
                    }
                    $q.all(promise).then(function () {
                      reloadPaginationDraft()
                      reloadPaginationPublish()
                      reloadPaginationArchived()
                      $state.reload()
                    })
                  })
                })
              })
            })
          } else {
            OffersService.save(model).then(function (resultOffer) {
              OffersService.listOfferSegmentation(item.id).then(function (result) {
                var offersSegmentations = result.results
                var promise = []
                for (var i = 0; i < offersSegmentations.length; i++) {
                  promise.push(
                    OffersService.addOfferSegmentation(
                      resultOffer.results.id,
                      offersSegmentations[i].id,
                    ),
                  )
                }
                $q.all(promise).then(function () {
                  reloadPaginationDraft()
                  reloadPaginationPublish()
                  reloadPaginationArchived()
                  $state.reload()
                })
              })
            })
          }
        }
      },
    )
  }

  vm.sort = function (type, isTab) {
    if (isTab === 1) {
      vm.sortReverse = !vm.sortReverse
      if (vm.sortReverse) {
        vm.sortType = type + '-asc'
      } else {
        vm.sortType = type + '-desc'
      }
      loadUnpublished(vm.pagination.current)
    } else if (isTab === 2) {
      vm.sortReverse2 = !vm.sortReverse2
      if (vm.sortReverse2) {
        vm.sortType2 = type + '-asc'
      } else {
        vm.sortType2 = type + '-desc'
      }
      loadPublished(vm.pagination2.current)
    } else {
      vm.sortReverse3 = !vm.sortReverse3
      if (vm.sortReverse3) {
        vm.sortType3 = type + '-asc'
      } else {
        vm.sortType3 = type + '-desc'
      }
      loadArchived(vm.pagination3.current)
    }
  }

  vm.arrowUp = function (item) {
    if (item.edit) {
      return
    }
    var copy = angular.copy(item)
    copy.n = copy.n - 1
    OffersService.update(item.id, {
      n: copy.n,
    }).then(function () {
      vm.sortType = 'n-asc'
      vm.sortReverse = false
      vm.sortType2 = 'n-asc'
      vm.sortReverse2 = false
      vm.sortType3 = 'ts-p-desc'
      vm.sortReverse3 = false
      loadUnpublished(vm.pagination.current)
      loadPublished(vm.pagination2.current)
      loadArchived(vm.pagination3.current)
    })
  }

  vm.arrowDown = function (item) {
    if (item.edit) {
      return
    }
    var copy = angular.copy(item)
    copy.n = copy.n + 1
    OffersService.update(item.id, {
      n: copy.n,
    }).then(function () {
      vm.sortType = 'n-asc'
      vm.sortReverse = false
      vm.sortType2 = 'n-asc'
      vm.sortReverse2 = false
      vm.sortType3 = 'ts-p-desc'
      vm.sortReverse3 = false
      loadUnpublished(vm.pagination.current)
      loadPublished(vm.pagination2.current)
      loadArchived(vm.pagination3.current)
    })
  }
}
